import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReusableModal from "../../../ExtraComponents/ReusableModal";
import { allServiceList, deleteService } from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import { getServiceType, updateService, getServiceApplicable } from "../../../ReduxStore/Slice/Pricing/ServiceSlice";
import { useDispatch } from "react-redux";
import Datatable from "../../../ExtraComponents/ReusableTable2";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { Trash2, PenLine } from "lucide-react";
import { PRICE_IS_ZERO, EMPTY_PRICE_ERROR } from "../../../Utils/Common_Error";
import ReactPaginate from "react-paginate";
import { getChargeBasisAllName } from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import { agentDetails } from "../../../ReduxStore/Slice/Auth/AuthSlice";


const AllService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const user_id = JSON.parse(localStorage.getItem("details")).id;
  const [getServiceData, setServiceData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPriceModal, setShowPrcieModal] = useState(false);
  const [serviceTypeData, setServiceTypeData] = useState([]);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [serviceApplicableData, setServiceApplicableData] = useState([]);
  const [priceChange, setPriceChange] = useState([]);
  const [InputValue, setInputValue] = useState('');
  const [filterArr, setFilterArr] = useState({ serviceType: '', vat_exempt: '' })
  const [rowTable, setRow] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [chargebasedata, setChargebasedata] = useState([])
  const [chargebasedatafilter, setChargebasedatafilter] = useState("")

  const savedValue = localStorage.getItem("chargeBasisFilter");
  const [agentData, setAgentData] = useState({});
   //console.log("serviceTypeData", serviceTypeData);

 useEffect(() => {
    const savedValue = localStorage.getItem("chargeBasisFilter");
    if (savedValue) {
      setChargebasedatafilter(savedValue);
    }
  }, []);

  const handleSelectChange = (value) => {
    setChargebasedatafilter(value);
    localStorage.setItem("chargeBasisFilter", value);
  };

  useEffect(() => {
    getAgentList();
    ServiceType();
    ServiceApplicable();
    getChargeBasisData();
  }, []);

  const getAgentList = async () => {
    const req = { agent_id: agent_id }
    await dispatch(agentDetails(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          //console.log("res -- agents details", res)
          setAgentData(res.data);
        }
        else {
          setAgentData({});
        }
      })
      .catch((err) => {
        console.log("Error", err)
      })
  }

  useEffect(() => {
    getAllService(1, pageSize, "");
  }, [InputValue, chargebasedatafilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])

  const ServiceType = async () => {
    const req = { token: token, agent_id: agent_id };
    try {
      const res = await dispatch(getServiceType(req)).unwrap();
      if (res.status) {
        setLoading(false);
        setServiceTypeData(res.data);
      } else {
        setLoading(false);
        setServiceTypeData([]);
      }
    } catch (error) {

    }
  };

  const getChargeBasisData = async () => {
    const req = {
      agent_id: agent_id,
    };
    await dispatch(getChargeBasisAllName(req)).unwrap()
      .then((response) => {
        setLoading(false);
        if (response.status) {
          setChargebasedata(response.data)

        } else {
          setChargebasedata([])
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
        setLoading(false);
      });
  };



  const ServiceApplicable = async () => {
    const req = { token: token, agent_id: agent_id };
    try {
      const res = await dispatch(getServiceApplicable(req)).unwrap();
      if (res.status) {
        setServiceApplicableData(res.data);
      } else {
        setServiceApplicableData([]);
      }
    } catch (error) {

    }
  };

  const getAllService = async (page = 1, limit = 10, term, type) => {
    const req = {
      page: page,
      pageSize: limit,
      servicename: "",
      agent_id: agent_id,
      servicename: InputValue,
      servicetype_id: type == 1 ? "" : filterArr.serviceType,
      vat_exempt: type == 1 ? "" : filterArr.vat_exempt.length == 2 ? "" : filterArr.vat_exempt[0],
      chargebasis_id: chargebasedatafilter || savedValue
    };
    await dispatch(allServiceList(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setServiceData(response.data);
          setShowModal(false);
          setTotalRecords(response?.totalCount);
        } else {
          setServiceData([]);
          setShowModal(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  useEffect(() => {
    getAllService(1, pageSize, "");
  }, [rowsPerPage]);

  const handlePageChange = (selected) => {
    const newPage = selected.selected + 1;
    setCurrentPage(newPage);
    getAllService(newPage, pageSize, '');
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
    getAllService(1, newSize, '');
  };

  const EditService = async (e, row, type) => {
    let newStatus;
    let alert_msg = "Service Type";
    if (type == "servicetype_id") {
      newStatus = e.target.value;
    } else if (type == "vat_exempt") {
      alert_msg = "VAT Exempt";
      newStatus = e.target.value;
    }

    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change ${alert_msg} of this service?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {

        try {
          let req;
          if (type == "servicetype_id") {
            req = { id: row.id, name: row.name, servicetype_id: newStatus, agent_id: agent_id, type: "servicetype_id", user_id: user_id };
          }
          else if (type == "vat_exempt") {
            req = { id: row.id, name: row.name, vat_exempt: newStatus, agent_id: agent_id, type: "vat_exempt", user_id: user_id };
          }

          const res = await dispatch(updateService(req)).unwrap();
          if (res.status) {
            Swal.fire({
              title: "Success",
              text: res.msg,
              icon: "success",
              timer: 1000,
              showConfirmButton: false,
            });
            getAllService(1, pageSize, "");
            setShowPrcieModal(false);
            setPriceChange([])


          } else {
            Swal.fire({
              title: "Error",
              text: res.msg,
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: "An error occurred while updating the status.",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Status change was not performed",
          icon: "error",
          timer: 1000,

          confirmButtonText: "Ok",
        });
      }
    });
  };

  const columns = [
    {
      name: "Service Name",
      cell: (row) => (
        <div title={row.name || ""} className="w-100">
          <div className="w-100">{row.name || ""}</div>
          {row.price_type == "2" && (
            <div
              style={{
                border: "1px solid #EAA7EF",
                borderRadius: "14px",
                padding: "2px 5px",
                lineHeight: "12px",
                width: "fit-content",
              }}
              className="mt-1 text-center">
              <small className="text-pink text-center">
                {row.price_type == "2" ? "Pricing Rule" : ""}
              </small>
            </div>
          )}
        </div>
      ),
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => Number(row.status) === 1 ? "Active" : "Inactive",
      sortable: true,
    },
    {
      name: "Service Type",
      cell: (row) => (
        <div>
          {
            <select
              className="form-select border formselect"
              id="floatingSelect"
              disabled={row.deleted ? false : true}
              aria-label="Floating label select example"
              value={row.servicetype_id}
              onChange={(e) => EditService(e, row, "servicetype_id")}

            >
              {serviceTypeData.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          }
        </div>
      ),
      selector: (row) => row.servicetype_id,
      sortable: true,
    },
    {
      name: "VAT Exempt",
      cell: (row) => (
        <div className="w-100">
          <select
            className="form-select formselect border"
            value={row.vat_exempt}
            onChange={(e) => EditService(e, row, "vat_exempt")}

          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      ),
      selector: (row) => row.vat_exempt,
      sortable: true,
    },
    {
      name: "Price",
      cell: (row) => (
        <div className='w-100'>
          {row.price_type == "1" ? "£ " + row.price :
            <button
              className="btn btn-link"
              onClick={() => {
                setShowPrcieModal(true);
                setRow(row);
              }}>
              {expandedRowId === row.id ? (
                <i className="text-pink bx bx-minus"></i>
              ) : (
                <i className=" text-pink ri-add-fill"></i>
              )}
            </button>
          }
        </div>
      ),
      sortable: false,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="w-100">
          <PenLine onClick={() => navigate(`/admin/pricing/edit-services`, { state: row })} />
          {row.PackageServices.length > 0 ? (
            ""
          ) : (
            <>

              <Trash2 onClick={() => handleDeleteService(row)} />
            </>
          )}
        </div>
      ),
      sortable: false,
    },
  ];

  const getColumns = () => {
    const baseColumns = [
      // {
      //   name: "Service Name",
      //   cell: (row) => (
      //     <div title={row.name || ""} className="w-100">
      //       <div className="w-100">{row.name || ""}</div>
      //       {row.price_type == "2" && (
      //         <div
      //           style={{
      //             border: "1px solid #EAA7EF",
      //             borderRadius: "14px",
      //             padding: "2px 5px",
      //             lineHeight: "12px",
      //             width: "fit-content",
      //           }}
      //           className="mt-1 text-center"
      //         >
      //           <small className="text-pink text-center">
      //             {"Pricing Rule"}
      //           </small>
      //         </div>
      //       )}
      //     </div>
      //   ),
      //   selector: (row) => row.name,
      //   sortable: true,
      // },
      {
        name: "Service Name",
        cell: (row) => (
          <div title={row.name || ""} className="w-100">
            <a
              href={`#/admin/pricing/view-services?id=${row?.id}&status=${row?.deleted}`}
              className="text-pink font-bold"
              style={{
                fontWeight: "bold",
              }}
              onClick={(e) => {
                if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
                  e.preventDefault();
                  navigate("/admin/pricing/view-services", {
                    state: row,
                  });
                }
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {row.name || ""}
            </a>

            {row.price_type == "2" && (
              <div
                style={{
                  border: "1px solid #EAA7EF",
                  borderRadius: "14px",
                  padding: "2px 5px",
                  lineHeight: "12px",
                  width: "fit-content",
                }}
                className="mt-1 text-center"
              >
                <small className="text-pink text-center">
                  Pricing Rule
                </small>
              </div>
            )}
          </div>
        ),
        selector: (row) => row.name,
        sortable: true,
      },
      {
        name: "Status",
        selector: (row) => Number(row.status) === 1 ? "Active" : "Inactive",
        sortable: true,
      },
      // {
      //   name: "Service Type",
      //   cell: (row) => (
      //     <div>
      //       <select
      //         className="form-select border formselect"
      //         id="floatingSelect"
      //         disabled={row.deleted ? false : true}
      //         aria-label="Floating label select example"
      //         value={row.servicetype_id}
      //         onChange={(e) => EditService(e, row, "servicetype_id")}
      //       >
      //         {serviceTypeData.map((item) => (
      //           <option key={item.id} value={item.id}>
      //             {item.name}
      //           </option>
      //         ))}
      //       </select>
      //     </div>
      //   ),
      //   selector: (row) => row.servicetype_id,
      //   sortable: true,
      // },
       {
        name: "Service Type",
        cell: (row) => (
          <div>
            <select
              className="form-select border formselect"
              id="floatingSelect"
              // disabled={row.deleted ? false : true}
              aria-label="Floating label select example"
              value={row.servicetype_id}
              onChange={(e) => EditService(e, row, "servicetype_id")}
            >
              {/* {serviceTypeData.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))} */}
              {serviceTypeData
                .filter((item) => !(row.deleted === false && item.id === 2))
                .map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>
        ),
        selector: (row) => row.servicetype_id,
        sortable: true,
      },
      {
        name: "Price",
        cell: (row) => (
          <div className="w-100">
            {row.price_type == "1" ? (
              "£ " + row.price
            ) : (
              <button
                className="btn btn-link"
                onClick={() => {
                  setShowPrcieModal(true);
                  setRow(row);
                }}
              >
                {expandedRowId === row.id ? (
                  <i className="text-pink bx bx-minus"></i>
                ) : (
                  <i className=" text-pink ri-add-fill"></i>
                )}
              </button>
            )}
          </div>
        ),
        sortable: false,
      },
      {
        name: "Action",
        cell: (row) => (
          <div className="w-100">
            <PenLine
              onClick={() =>
                navigate(`/admin/pricing/edit-services`, { state: row })
              }
            />
            {row.PackageServices.length > 0 ? null : (
              <Trash2 onClick={() => handleDeleteService(row)} />
            )}
          </div>
        ),
        sortable: false,
      }
    ];
    // 👇 Insert VAT Exempt at index 3 (i.e., before Price column)
    if (agentData?.vat_registered === "YES") {
      baseColumns.splice(3, 0, {
        name: "VAT Exempt",
        cell: (row) => (
          <div className="w-100">
            <select
              className="form-select formselect border"
              value={row.vat_exempt}
              onChange={(e) => EditService(e, row, "vat_exempt")}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        ),
        selector: (row) => row.vat_exempt,
        sortable: true,
      });
    }
    return baseColumns;
  };

  const handleDeleteService = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this service?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, agent_id: agent_id };
        await dispatch(deleteService(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: "Success",
                text: "Service Deleted Successfully",
                icon: "success",
                timer: 7000,
                timerProgressBar: true,
              });
              getAllService(1, pageSize, "");
            }
          })
          .catch((error) => {
            console.error("Error deleting package:", error);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });

  }

  const handlePriceChange = (chargetype_rule_value, rowId, chargebasis_id, chargetype_rule_id, operator, servicechargebasisvalues_id, change_status, currentValue) => {

    if (change_status == 0 || change_status == undefined) {
      change_status = chargetype_rule_value !== currentValue ? "1" : "0";
    }

    if (!/^\d*\.?\d*$/.test(chargetype_rule_value)) return;

    setPriceChange((prevPriceChange) => {
      const existingEntryIndex = prevPriceChange.findIndex(
        (item) =>
          item.id === rowId &&
          item.chargebasis_id === chargebasis_id &&
          item.chargetype_rule_id === chargetype_rule_id
      );
      if (existingEntryIndex !== -1) {
        const updatedPriceChange = [...prevPriceChange];
        updatedPriceChange[existingEntryIndex].chargetype_rule_value =
          chargetype_rule_value;
        return updatedPriceChange;
      } else {
        return [
          ...prevPriceChange,
          {
            id: rowId,
            chargebasis_id,
            chargetype_rule_id,
            chargetype_rule_value,
            operator: operator,
            servicechargebasisvalues_id: servicechargebasisvalues_id,
            change_status: change_status,
          },
        ];
      }
    });
  };

  const getPriceValue = (rowId, chargebasis_id, chargetype_rule_id, chargeType) => {

    const match = priceChange && priceChange.find(
      (item) =>
        item.id == rowId &&
        item.chargebasis_id == chargebasis_id &&
        item.chargetype_rule_id == chargetype_rule_id
    );

    return match ? match.chargetype_rule_value : chargeType.value;
  };

  const serviceTypeFilterArr = [
    { value: "1", label: "Recurring" },
    { value: "2", label: "One-off" },
    { value: "3", label: "Both" },
    { value: "4", label: "With Package Only" },
  ];

  const vatFilterArr = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
  ];


  const handleAddService = (e) => {
    navigate("/admin/pricing/create-services");
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">Services</h4>
        </div>
        <div className="col-auto align-self-center">
          <div
            onClick={(e) => handleAddService(e)}
            className="btn btn-pink"
            id="Dash_Date">
            <span className="ay-name" id="Day_Name">
              Add New Service
            </span>
          </div>
        </div>
      </div>

      <section className="section dashboard">
        <div className="row">
          <data className="col-lg-3 datatable-search">
            <input
              type="text"
              className="search p-2 icon"
              placeholder="Search here"
              value={InputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </data>

          <div className="col-lg-3 filter-select mb-3 select_tab">
            {/* <select
              onChange={(e) => setChargebasedatafilter(e.target.value)}
              value={chargebasedatafilter}
              className="form-select"
            >
              <option value="">Select Charge Basis</option>
              {chargebasedata?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select> */}
            <select
              onChange={(e) => handleSelectChange(e.target.value)}
              value={chargebasedatafilter}
              className="form-select"
            >
              <option value="">Select Charge Basis</option>
              {chargebasedata?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-5">
            <button
              className="btn w-auto filter-btn p-0"
              onClick={handleShowModal}>
              <i className="bi bi-filter fs-3 text-pink"></i>
            </button>
            <button
              className="btn btn-pink ms-4"
              onClick={() => {
                localStorage.removeItem("chargeBasisFilter");
                setChargebasedatafilter("")
                setFilterArr({ serviceType: "", vat_exempt: "", chargeBasisType: "" });
                getAllService(1, pageSize, "", 1);
              }}>
              Clear Filter
            </button>
          </div>
          <div></div>
        </div>



        <div className="">

          <Datatable
            columns={getColumns()}
            data={getServiceData}
            filter={false}
            loading={loading}
          />

          {getServiceData.length > 0 ? <div>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />

            <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={0}>{"ALL"}</option>


            </select>
          </div> : ""}
        </div>
      </section>
      <ReusableModal
        show={showModal}
        onClose={handleCloseModal}
        title={
          <>
            <i className="bi bi-filter" style={{ marginRight: "8px" }}></i>
            Filters
          </>
        }
        body={
          <div className="service-filter ps-2">
            <div className="row mb-5">
              <p className="text-semidark mb-2 font-14">Service Type</p>
              <div className="col-sm-12 d-flex">
                {serviceTypeFilterArr.map((item) => (
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked={filterArr.serviceType.includes(
                        item.value
                      )}
                      value={item.value}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFilterArr((prev) => ({
                            ...prev,
                            serviceType: [...prev.serviceType, e.target.value],
                          }));
                        } else {
                          setFilterArr((prev) => ({
                            ...prev,
                            serviceType: prev.serviceType.filter(
                              (type) => type !== e.target.value
                            ),
                          }));
                        }
                      }}
                    />
                    <label className="form-check-label ms-1">
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="row mb-5">
              <p className="text-semidark mb-3 font-14">VAT Exempt</p>
              <div className="col-sm-12 d-flex">
                {vatFilterArr?.map((item) => (
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked={filterArr?.vat_exempt?.includes(item.value)}
                      value={item.value}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFilterArr((prev) => ({
                            ...prev,
                            vat_exempt: [...prev.vat_exempt, e.target.value],
                          }));
                        } else {
                          setFilterArr((prev) => ({
                            ...prev,
                            vat_exempt: prev.vat_exempt.filter(
                              (type) => type !== e.target.value
                            ),
                          }));
                        }
                      }}
                    />
                    <label className="form-check-label ms-1">
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="row"></div>
          </div>
        }
        footer={
          <>
            <button
              className="btn btn-outline-secondary"
              onClick={handleCloseModal}>
              Cancel
            </button>
            <button className="btn btn-pink" onClick={() => getAllService(1, pageSize, "")}>
              Apply
            </button>
          </>
        }
      />
      <ReusableModal
        show={showPriceModal}
        onClose={() => { setShowPrcieModal(false); setPriceChange([]) }}
        title={""}
        body={
          <div className="service-filter service-plus-modal ps-2">
            {rowTable?.ServiceChargeBases?.map((item, index) => (
              <div key={index} className="mb-4">
                <h6 className="text-pink mb-1">Charge Basis {index + 1}</h6>
                <hr className="my-2" />

                <div className="d-flex">
                  <div className="w-50 pe-3">
                    <b className="fw-300">{item?.ChargeBasis?.name}</b>
                  </div>
                  <div className="w-50">
                    <b className="text-pink">Price</b>
                  </div>
                </div>

                {
                  item?.ServiceChargeBasisValues.length > 0 ? (
                    item?.ServiceChargeBasisValues?.map((chargeType, idx) => (
                      <div key={chargeType?.id || idx} className="d-flex">
                        <div className="w-50 pe-3">
                          <ul className="list-unstyled mt-2">
                            <li className="mb-2">{chargeType?.ChargeType?.name}</li>
                          </ul>
                        </div>
                        <div className="w-50">

                          {/* <input
                            disabled
                            type="text"
                            className="form-control mb-2"
                            onChange={(e) =>
                              handlePriceChange(
                                e.target.value,
                                rowTable.id,
                                item.ChargeBasis.id,
                                chargeType.ChargeType.id,
                                item.operator,
                                chargeType.id,
                                item.change_status,
                                chargeType?.value
                              )
                            }
                            value={getPriceValue(
                              rowTable?.id,
                              item?.ChargeBasis?.id,
                              chargeType?.ChargeType?.id,
                              chargeType
                            )}
                          /> */}

                          {getPriceValue(
                            rowTable?.id,
                            item?.ChargeBasis?.id,
                            chargeType?.ChargeType?.id,
                            chargeType
                          )}

                        </div>
                      </div>
                    ))
                  )
                    :

                    item?.ChargeBasis?.BasisType?.id == 1 ? (
                      <>
                        <div className="d-flex">
                          <div className="w-50">
                            Per Unit Rate
                          </div>
                          <div className="w-50">
                            {item?.price_rate || ""}
                          </div>
                        </div>

                        <div className="d-flex">
                          <div className="w-50">
                            Min Base Price
                          </div>
                          <div className="w-50">
                            {item?.min_base_price || ""}
                          </div>
                        </div>

                      </>
                    )
                      :


                      item?.ChargeBasis?.BasisType?.id == 2 ? (
                        <>
                          <div className="d-flex">
                            <div className="w-50">
                              Per Hour Rate
                            </div>
                            <div className="w-50">
                              {item?.price_rate || ""}
                            </div>
                          </div>

                        </>
                      )

                        :
                        item?.ChargeBasis?.BasisType?.id == 6 ? (
                        <>
                          <div className="d-flex">
                            <div className="w-50">
                              Fixed Rate
                            </div>
                            <div className="w-50">
                              {item?.price_rate || ""}
                            </div>
                          </div>

                        </>
                      )
                        :

                        item?.ChargeBasis?.BasisType?.id == 5 ?
                          Number(item?.ChargeBasis?.incremental_price) == 1 ?

                            <>
                              <div className="d-flex">
                                <div className="w-50">
                                  Incremental Price
                                </div>
                                <div className="w-50">
                                  {item?.incremental_price || ""}
                                </div>
                              </div>

                              <div className="d-flex">
                                <div className="w-50">
                                  Min Base Price
                                </div>
                                <div className="w-50">
                                  {item?.min_base_price || ""}
                                </div>
                              </div>

                            </>

                            :

                            <>
                              <div className="d-flex">
                                <div className="w-50">
                                  Per Unit Rate
                                </div>
                                <div className="w-50">
                                  {item?.price_rate || ""}
                                </div>
                              </div>

                              <div className="d-flex">
                                <div className="w-50">
                                  Min Base Price
                                </div>
                                <div className="w-50">
                                  {item?.min_base_price || ""}
                                </div>
                              </div>

                            </>

                          :
                          ""
                }

              </div>
            ))}
          </div>

        }
      // footer={
      //   <>
      //     <button className="btn btn-outline-secondary" onClick={() => { setShowPrcieModal(false); setPriceChange([]) }}>Cancel</button>
      //     <button className="btn btn-pink" onClick={(e) => EditService(priceChange, rowTable, "Price")}>save</button>
      //   </>
      // }
      />
    </div>
  );
};

export default AllService;
